import { env } from "@/env";

const logger = createDebugConsole(window.console, {
  enabled: env.isDebug,
});

export { logger };

interface DebugConsoleOptions {
  enabled?: boolean;
}

function createDebugConsole(
  consoleObj: Console,
  options: DebugConsoleOptions = {},
): Console {
  const nextConsoleObj = { ...consoleObj } as Record<string, unknown>;
  const { enabled = true } = options;

  const hasOwn = Object.prototype.hasOwnProperty;

  for (const key in nextConsoleObj) {
    if (
      hasOwn.call(nextConsoleObj, key) &&
      typeof nextConsoleObj[key] === "function"
    ) {
      const originalFunc = nextConsoleObj[key] as (
        ...args: unknown[]
      ) => unknown;
      nextConsoleObj[key] = (...args: unknown[]) => {
        if (enabled) {
          originalFunc.apply(consoleObj, args);
        }
      };
    }
  }

  return nextConsoleObj as unknown as Console;
}
